/**
 * @overview 问卷模版新增编辑页面
 * @author xyguo
 * @date 2024-1-19
 */
import React from 'react';
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import { WizTableForm, WizDataAuthSelect } from '../../../common'
import moment from 'moment';
let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool;
let {WizForm, WizButton, WizRow, WizCol, WizSpin, WizCustomSteps, WizNotice, Wizmessage} = component_tool;
let {Session} = utils_tool;


class LiveNotice extends WizContainer {

  componentName = 'surveyTemplateDetail';

  constructor(props) {
    super(props);
    this.initialValue = props.noticeInitInfo
  }

  _componentDidMount() {
    this.doActions([
      {
          path: 'noticeTemplate/noticeInfoList',
          payload: {
              key: 'noticeTemplate@noticeInfoList',
              apiParams: {
                  bizType: 63,
              }
          }
      },
  ]);
  }

  propsAndStateOnChange = {
  }

  columns = () => {
   let initialValue = this.initialValue || {}
   let {rowKey,id,authCmd,templateId,content,templateDefineId,filterParticipants,assignTime,authInfo,templateContent} = initialValue
   let {noticeInfoList,liveName,startTime,initAuthCmd,endTime,hostName} = this.props
   let noticeInfoDict = [];
   if(noticeInfoList.data && noticeInfoList.data.length){
    noticeInfoList.data.forEach(element => {
      let entity = {code:element.sceneInfoList[0].id,codeName:element.sceneName,content:element.sceneInfoList[0].content}
      noticeInfoDict.push(entity)
    });
   }
   if(content && content.indexOf("${name}")!=-1 && hostName){
      content = content.replace(/\$\{name\}/g, hostName);
   }
   if(content && content.indexOf("${liveName}")!=-1 && liveName){
      content = content.replace(/\$\{liveName\}/g, liveName);
   }
   if(content && content.indexOf("${startTime}")!=-1 && startTime){
      content = content.replace(/\$\{startTime\}/g, moment(startTime).format("YYYY-MM-DD HH:mm"));
   }
   if(content && content.indexOf("${endTime}")!=-1 && endTime){
    content = content.replace(/\$\{endTime\}/g, moment(endTime).format("YYYY-MM-DD HH:mm"));
   }

    return [
      {
        name: "rowKey",
        formItem: {
          type: "hidden",
          initialValue: rowKey ? rowKey : templateDefineId ? templateDefineId : new Date().getTime()
        }
      },
      {
        name: "templateDefineId",
        formItem: {
          type: "hidden",
          initialValue: templateDefineId
        }
      },
      {
        name: "sendState",
        formItem: {
          type: "hidden",
          initialValue: 0
        }
      },
      {
        name: "noticeWhitelist",
        formItem: {
          type: "hidden",
          initialValue: 0
        }
      },
      {
        name: "state",
        formItem: {
          type: "hidden",
          initialValue: 1
        }
      },
      {
        name: "sendType",
        formItem: {
          type: "hidden",
          initialValue: 3
        }
      },
      {
        name: "appIds",
        formItem: {
          type: "hidden",
          initialValue: []
        }
      },
      {
        name: "code",
        formItem: {
          type: "hidden",
          initialValue: ""
        }
      },
      {
        name: "templateContent",
        formItem: {
          type: "hidden",
          initialValue: templateContent,
        },
      },
      {
        title: "短信模板",
        name: "id",
        dataIndex: "id",
        dict: noticeInfoDict,
        formItem: {
          type: 'select',
          onChange: (a,b)=>{
            noticeInfoDict.map((e, index) => {
              if(e.code==b){
                let contentInfo = e.content
                if(contentInfo.indexOf("${name}")!=-1 && hostName){
                  contentInfo = contentInfo.replace(/\$\{name\}/g, hostName);
                }
                if(contentInfo.indexOf("${liveName}")!=-1 && liveName){
                  contentInfo = contentInfo.replace(/\$\{liveName\}/g, liveName);
                }
                if(contentInfo.indexOf("${startTime}")!=-1 && startTime){
                  contentInfo = contentInfo.replace(/\$\{startTime\}/g, moment(startTime).format("YYYY-MM-DD HH:mm"));
                }
                if(contentInfo.indexOf("${endTime}")!=-1 && endTime){
                  contentInfo = contentInfo.replace(/\$\{endTime\}/g, moment(endTime).format("YYYY-MM-DD HH:mm"));
                }
                a.setFieldsValue({
                  content: contentInfo,
                  templateContent : e.content
              });
              }
            })
          },
          rules: [
            {
              required: true,
              message: '请选择短信模板'
            }
          ],
          initialValue: templateId?templateId:id,
        },
      },
      {
        title: "短信内容",
        name: "content",
        dataIndex: "content",
        formItem: {
          disabled: true,
          type: 'textarea',
          rows:3,
          initialValue: content,
        },
      },
      {
        title: '短信受众',
        name: 'authCmd',
        formItem: {
          type: 'diy',
          diy: WizDataAuthSelect,
          mode: 'Form',
          initialValue: authInfo ? authInfo : authCmd ? authCmd : initAuthCmd ? initAuthCmd :{},
          record: {
            authCmd: authInfo ? authInfo : authCmd ? authCmd : initAuthCmd ? initAuthCmd : {},
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
          rules: [
            {
              required: true,
              message: '请选择短信受众'
            }
          ]
        }
      },
      {
        title: "过滤已参训学员",
        name: "filterParticipants",
        dataIndex: "filterParticipants",
        dict: [
          {code: 1, codeName: "是"},
          {code: 0, codeName: "否"}
        ],
        formItem: {
          type: 'radio',
          rules: [
            {
              required: true,
              message: '请选择过滤已参训学员'
            }
          ],
          initialValue: filterParticipants===0 ? 0 : 1,
        },
      },
      {
        title: "短信发送时间",
        name: "assignTime",
        dataIndex: "assignTime",
        formItem: {
          type: 'date',
          showTime: {format: 'HH:mm'},
          format: 'YYYY-MM-DD HH:mm',
          rules: [
            {
              required: true,
              message: '请选择短信发送时间'
            }
          ],
          initialValue: assignTime ? new Date(assignTime) : null,
        },
      },
    ]
  }

  _onSubmit(values) {
    this.props.saveLiveNotice(values);
  }

  _render() {
    let formProps = {
      ref: 'form',
      columns: this.columns(),
      onSubmit: this._onSubmit.bind(this),
      record: null,
      preview: null,
     // footer: null,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      },
      style: { width: '100%' }
    }

    return (
          <WizForm className={'form-inline'} {...formProps} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {noticeTemplate} = state;
  const noticeInfoList = modelUtils.getModelEntity(noticeTemplate, 'noticeTemplate@noticeInfoList')
  return {
    noticeInfoList,
  };
};

export default connect(mapStateToProps)(LiveNotice);
